// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#dashboard-block-4 #Department .list-category-items .items span{color:#a3a3a3;font-size:12px}#dashboard-block-4 #Department .list-category-items .items .value{font-size:16px;font-weight:700}#dashboard-block-4 #Department .scrollbar-container{max-height:350px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
